import { Form as AntForm } from 'antd';

/**
 * Global Form component. Wraps Ant Design Form so the app uses one place for form.
 * Pass any params (form, onFinish, layout, requiredMark, autoComplete, etc.) as needed per screen.
 */
export const Form = AntForm;
export const FormItem = AntForm.Item;
